import 'babel-polyfill'
import Vue from 'vue'
import App from './ConsignorApp.vue'
import { createRouter } from './router/consignorIndex'
import store from './store'
import pluginCore from './plugins/core'
import './assets/css/common.scss'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/common.styl'
// import '@/permission.js'
import * as filters from './filters' // global filters
import Print from 'vue-print-nb'
import Popup from '@/components/specialDialog/index'
import htmlToPdf from '@/assets/js/htmlToPdf'
import './assets/iconfont/iconfont.css'
import './icons' // icon
import permission from '@/directive/permission/index'
import Plugins from '@/directive/permission/Plugins'
import accessMenu from '@/directive/accessMenu/index'
import buriedPoint from '@/assets/js/buriedPoint'
import commonFunction from  './plugins/commonFunction'
import publickVueFun from './plugins/publickVueFun'
import uploadLogic from '@zczy/upload-logic/dist/index.common.js'
import ZczyFrame from '@zczy/frame'
import {
	formatImgUrl,copyText
  } from '@/assets/utils/utils'
  console.log('Before mounting:', Vue.prototype.$formatImgUrl);
import '@zczy/css/lib/cargo/index.css';
import ZczyButton from '@zczy/button'

Vue.use(ZczyButton, { time: 2000 })

Vue.prototype.$formatImgUrl = formatImgUrl
Vue.prototype.$uploadLogic = uploadLogic.uploadFile
require('./plugins/jsCompute')

Vue.prototype.bus = new Vue()
Vue.use(permission)
Vue.use(Plugins)
Vue.use(accessMenu)
Vue.use(publickVueFun)
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})
Vue.use(ZczyFrame)
const router = createRouter()

Vue.config.productionTip = false
Vue.use(Print) // 注册
Vue.use(Popup)
Vue.use(htmlToPdf)
Vue.use(pluginCore)
Vue.$router = router
Vue.use(buriedPoint)
window.commonFunction = commonFunction
try{
  if(COOPERATION_NAME == 'zaozhuang_zhiyun'){
    const link = document.querySelector("link[rel~='icon']");
  if (link) {
    link.href = './zklogo.png'; // 替换为你的新图标路径
  } else {
    // 如果没有现有的 favicon 链接，创建一个新的
    const newLink = document.createElement('link');
    newLink.rel = 'icon';
    newLink.href = './zklogo.png'; // 替换为你的新图标路径
    document.head.appendChild(newLink);
  }
  }
  if(COOPERATION_NAME == 'forun_zhiyun'){
    const link = document.querySelector("link[rel~='icon']");
  if (link) {
    link.href = './frlogo.png'; // 替换为你的新图标路径
  } else {
    // 如果没有现有的 favicon 链接，创建一个新的
    const newLink = document.createElement('link');
    newLink.rel = 'icon';
    newLink.href = './frlogo.png'; // 替换为你的新图标路径
    document.head.appendChild(newLink);
  }
  }
}catch(e){
  console.log(e)
}

Vue.prototype.copy = copyText


console.log('子应用获取数据', window)

if (window.__MICRO_APP_ENVIRONMENT__) {
  const data = window.microApp.getData()
  
  console.log('子应用获取数据', window)

  if (data.token) {
    localStorage.setItem('tokenId', data.token);
    localStorage.setItem('uuUserId', data.userInfo.userId)
    localStorage.setItem('byPrmFlag', '1')
  }
}
// 全局窗口大小管理
const windowSize = Vue.observable({
  width: window.innerWidth,
  height: window.innerHeight,
  isSmallScreen: window.innerWidth < 1300
});

let resizeTimer = null;
const updateWindowSize = () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    windowSize.width = window.innerWidth;
    windowSize.height = window.innerHeight;
    windowSize.isSmallScreen = window.innerWidth < 1300;
  }, 100);
};

window.addEventListener('resize', updateWindowSize);

// 挂载到Vue原型上，所有组件都可以通过this.$windowSize访问
Vue.prototype.$windowSize = windowSize;
// window.addEventListener('message', function (event) {
//     if(event.origin === 'http://192.168.87.24:8081'){
//         console.log('tokenId', event.data)
//         console.log('event', JSON.stringify(event))
//         localStorage.setItem('tokenId', event.data);
//     }
// }, false);
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')


